<script>
	import MenuItemComponent from "./MenuItem/MenuItemComponent.svelte";
	import {Router, Route} from "svelte-routing";
	import Modal from 'svelte-simple-modal';
	import ContentItemComponent from "./Contents/ContentItemComponent.svelte";
	import Footer from "./Footer.svelte";
	import Header from "./Header/Header.svelte";
	import NotFound from "./NotFound.svelte";
	import PrintProductOffers from "./Contents/EmbeddableComponents/PrintProductOffers.svelte";
	import HeaderPrint from "./Header/HeaderPrint.svelte";

	export let url = ""; //This property is necessary declare to avoid ignore the Router
	export let config;

</script>

<Router url="{url}">

	<Modal>
		<main>

			<Route path="/">
<!--				<Header {config} mid="105" />-->
<!--				<MenuItemComponent {config} minfo="Chronik-m-104" />-->
<!--				<Header {config} mid="-1" />-->
<!--				<Home />-->
<!--				<HeaderPrint {config} />-->
<!--				<PrintProductOffers {config} mid="103" />-->
				<Header {config} mid="101" />
				<MenuItemComponent {config} minfo="Start-m-101" />
				<Footer {config} />
			</Route>

			<Route path="site/:info" let:params>
				<Header {config} mid="{params.info.split('-m-')[1]}" />
				<MenuItemComponent {config} minfo="{params.info}" />
				<Footer {config} />
			</Route>

			<Route path="content/:info" let:params>
				<Header {config} cid="{params.info.split('-c-')[1]}" />
				<ContentItemComponent {config} cinfo="{params.info}" />
				<Footer {config} />
			</Route>

			<Route path="print-offers">
				<HeaderPrint {config} />
				<PrintProductOffers {config} mid="103" />
			</Route>

			<Route path="not-found">
				<Header {config} mid="-2" />
				<NotFound />
				<Footer {config} />
			</Route>

			<Route>
				<Header {config} mid="-2" />
				<NotFound />
				<Footer {config} />
			</Route>

		</main>
	</Modal>

</Router>

<style>
	main {
		background-color: #93c12a;
	}

	@media print {
		main {
			background-color: #fff;
		}
	}
</style>
